<template>
    <v-container>
      <v-row>
        <v-col cols="12" md="12" class="pa-6 text-left text-justify">
            <schedule-training-form :trainingNameProp="$route.query.training_name" :dateProp="$route.query.date"/>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import ScheduleTrainingForm from "@/modules/forms/ScheduleTrainingForm";
  export default {
  
    components: {ScheduleTrainingForm}
  }
  </script>